/* Grimorio theme — predictive search via the Section Rendering API */

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-results]');
    if (!this.input || !this.results) return;

    this.input.addEventListener(
      'input',
      debounce(() => this.onInput(), 250)
    );
    this.input.setAttribute('role', 'combobox');
    this.input.setAttribute('aria-expanded', 'false');
  }

  onInput() {
    const query = this.input.value.trim();
    if (query.length < 2) {
      this.close();
      return;
    }
    this.search(query);
  }

  search(query) {
    const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(
      query
    )}&resources[limit]=6&section_id=predictive-search`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const fresh = parsed.querySelector('#PredictiveSearchResults');
        if (fresh) {
          this.results.innerHTML = fresh.innerHTML;
          this.results.classList.remove('hidden');
          this.input.setAttribute('aria-expanded', 'true');
        }
      })
      .catch(() => this.close());
  }

  close() {
    this.results.innerHTML = '';
    this.results.classList.add('hidden');
    this.input.setAttribute('aria-expanded', 'false');
  }
}
customElements.define('predictive-search', PredictiveSearch);
